module.exports = {
  name: '',
  description: '',
  slug: '',
  sdkVersion: '14.0.0',
  version: '1.0.0',
  orientation: 'portrait',
  primaryColor: '#cccccc',
  icon: 'https://s3.amazonaws.com/exp-icon-assets/ExpoEmptyManifest_192.png',
  loading: {
    icon: 'https://s3.amazonaws.com/exp-icon-assets/ExpoEmptyManifest_192.png',
    hideExponentText: false,
  },
  packagerOpts: {
    assetExts: ['ttf'],
  },
};
